export default "__VITE_ASSET__873addc2__"